import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.find";
import _typeof from "E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CustomerRecord',
  data: function data() {
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      loading: false,
      showMoreFilter: false,
      // 控制更多筛选条件的显示与隐藏
      recordList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      createDialogVisible: false,
      isEdit: false,
      // 是否为编辑状态
      currentRecord: {},
      // 添加 fromPageCall 标识是否来自页面跳转
      fromPageCall: false,
      createForm: {
        contact: '',
        aid: '',
        store_id: '',
        goods_sn: '',
        goods_type: '3',
        record_type: '4',
        content: '',
        record: '',
        status: '0',
        add_person: '',
        img_list: [] // 添加图片列表字段
      },
      // 问题类型选项
      recordTypeOptions: [{
        label: '用户咨询',
        value: '1'
      }, {
        label: '用户投诉',
        value: '2'
      }, {
        label: '用户回访',
        value: '3'
      }, {
        label: '商户回访',
        value: '4'
      }, {
        label: '代理回访',
        value: '5'
      }, {
        label: '业务员回访',
        value: '6'
      }, {
        label: '推广员回访',
        value: '7'
      }, {
        label: '合伙人回访',
        value: '8'
      }, {
        label: '其他',
        value: '0'
      }],
      // 处理状态选项
      statusOptions: [{
        label: '待处理',
        value: '0'
      }, {
        label: '已处理',
        value: '1'
      }],
      // 设备类型选项（根据实际需求添加）
      goodsTypeOptions: [{
        label: '其他',
        value: '0'
      }, {
        label: '充电宝',
        value: '1'
      }, {
        label: '充电线',
        value: '3'
      }, {
        label: '充电桩',
        value: '5'
      }, {
        label: '套套机',
        value: '9'
      }, {
        label: '蓝牙桌面充电宝',
        value: '11'
      }],
      agentList: [],
      // 代理列表
      storeList: [],
      // 商户列表
      agentSearchTimer: null,
      // 代理搜索防抖定时器
      storeSearchTimer: null,
      // 商户搜索防抖定时器
      queryParams: {}
    }, "showMoreFilter", false), "uploadUrl", 'https://api.szdianlala.com/Image/uploadImage'), "dialogImageUrl", ''), "dialogVisiblePreview", false), "fileList", []);
  },
  created: function created() {
    // 获取goods、record、status等类型列表.
    this.getTypeList();
    // 检查路由参数中是否有 page_call_type
    var pageCallType = this.$route.query.page_call_type;
    // 如果是查询模式，则设置 store_id 参数
    if (pageCallType === 'query') {
      // 如果有 store_id 参数，则设置为默认查询条件
      var storeId = this.$route.query.store_id;
      this.fetchStoreList('', storeId);
      this.queryParams.store_id = storeId;
    }
    // 检查路由参数中是否有 create_mode
    if (pageCallType === 'create') {
      // 如果是创建模式，则设置 contact 、aid 、store_id 等参数
      this.fetchAgentList('', this.$route.query.aid);
      this.fetchStoreList('', this.$route.query.store_id);
      this.handleCreate(this.$route.query.aid, this.$route.query.store_id, this.$route.query.phone, this.$route.query.business_des, this.$route.query.goods_type);
      // 设置来自页面跳转标识
      this.fromPageCall = true;
    }
    this.fetchData();
  },
  methods: {
    /**
     * 获取跟进记录列表
     */
    fetchData: function fetchData() {
      var _this = this;
      this.loading = true;
      // 处理日期范围参数
      var params = _objectSpread({
        page: this.currentPage,
        limit: this.pageSize
      }, this.queryParams);

      // 如果有日期范围，将其转换为"开始日期|结束日期"格式的字符串
      if (this.queryParams.add_date && this.queryParams.add_date.length === 2) {
        params.add_date = this.queryParams.add_date[0] + '|' + this.queryParams.add_date[1];
      }
      this.$get('agentapi/customer_record/get', params).then(function (res) {
        _this.recordList = res.list;
        _this.total = res.count;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    /**
     * 上传前检查
     */
    beforeUpload: function beforeUpload(file) {
      // 检查文件数量是否超过限制
      if (this.fileList.length >= 5) {
        this.$message.warning('最多只能上传5张图片');
        return false;
      }

      // 可以添加其他检查，如文件类型、大小等
      return true;
    },
    /**
     * 分页
     */
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    /**
     * 查看详情
     * @param row
     */
    handleView: function handleView(row) {
      this.currentRecord = _objectSpread({}, row);
      this.dialogVisible = true;
    },
    /**
     * 查询
     */
    handleFilter: function handleFilter() {
      this.currentPage = 1;
      this.fetchData();
    },
    /**
     *  编辑
     * @param row
     */
    handleEdit: function handleEdit(row) {
      // 设置编辑状态
      this.isEdit = true;
      // 将行数据填充到表单中
      this.createForm = {
        id: row.id,
        contact: row.contact,
        aid: row.aid,
        store_id: row.store_id,
        goods_sn: row.goods_sn,
        goods_type: this.getGoodsTypeValue(row.goods_type_name),
        // 根据中文类型获取对应的值
        record_type: this.getRecordTypeValue(row.record_type_name),
        // 根据中文类型获取对应的值
        content: row.content,
        record: row.record,
        status: this.getStatusValue(row.record_status_name),
        // 根据中文状态获取对应的值
        add_person: row.add_person,
        img_list: row.img_list || [] // 添加图片列表字段
      };

      // 获取并设置代理和商户的名称用于回显
      if (row.aid) {
        this.agentList = [{
          id: row.aid,
          name: row.admin_user_name
        }];
      }
      if (row.store_id) {
        this.storeList = [{
          id: row.store_id,
          store_name: row.store_name
        }];
      }

      // 设置图片列表用于编辑时显示
      // img_list直接是URL数组
      var imageUrls = Array.isArray(row.img_list) ? row.img_list : [];
      this.fileList = imageUrls.map(function (url, index) {
        return {
          name: "image_".concat(index, ".jpg"),
          url: url
        };
      });
      this.createDialogVisible = true;
    },
    /**
     * 处理取消或返回操作
     */
    handleCancelOrBack: function handleCancelOrBack() {
      this.createDialogVisible = false;
      // 如果来自页面跳转，则返回上一页
      if (this.fromPageCall) {
        this.$router.go(-1);
      }
      // 清空图片列表
      this.fileList = [];
      this.createForm.img_list = [];
    },
    /**
     * 获取goods、record、status等类型
     */
    getTypeList: function getTypeList() {
      var _this2 = this;
      this.$get('agentapi/customer_record/get_options_list', {}).then(function (res) {
        // 处理 goodsTypeOptions
        if (res.goods_options) {
          _this2.goodsTypeOptions = Object.keys(res.goods_options).map(function (key) {
            return {
              value: key,
              label: res.goods_options[key]
            };
          });
        }

        // 处理 recordTypeOptions
        if (res.record_options) {
          _this2.recordTypeOptions = res.record_options.map(function (label, value) {
            return {
              value: value.toString(),
              label: label
            };
          });
        }

        // 处理 statusOptions
        if (res.status_options) {
          _this2.statusOptions = res.status_options.map(function (label, value) {
            return {
              value: value.toString(),
              label: label
            };
          });
        }
      });
    },
    /**
     * 提交新建/编辑记录表单
     */
    submitCreateForm: function submitCreateForm() {
      var _this3 = this;
      this.$refs.createForm.validate(function (valid) {
        if (valid) {
          // 更新图片列表，直接使用URL数组
          _this3.createForm.img_list = _this3.fileList.map(function (file) {
            return file.url;
          }).filter(function (url) {
            return url;
          });
          if (_this3.isEdit) {
            // 编辑模式
            // 【操作埋点】2026-05-25 pc_customer_record_update_1 编辑客服跟进记录
            _this3.$put('agentapi/customer_record/update', _this3.createForm).then(function (res) {
              _this3.$customerRecordReport.reportCustomerRecordUpdate(_this3.createForm.id, _this3.createForm);
              _this3.$message({
                message: '更新成功',
                type: 'success'
              });
              _this3.createDialogVisible = false;
              _this3.fetchData(); // 重新加载数据
              // 清空图片列表
              _this3.fileList = [];
              _this3.createForm.img_list = [];
            }).catch(function (err) {
              _this3.$message({
                message: '更新失败',
                type: 'error'
              });
            });
          } else {
            // 新建模式
            // 【操作埋点】2026-05-25 pc_customer_record_create_1 新建客服跟进记录
            _this3.$post('agentapi/customer_record/create', _this3.createForm).then(function (res) {
              _this3.$customerRecordReport.reportCustomerRecordCreate(_this3.createForm);
              _this3.$message({
                message: '创建成功',
                type: 'success'
              });
              _this3.createDialogVisible = false;
              _this3.fetchData(); // 重新加载数据
              // 清空图片列表
              _this3.fileList = [];
              _this3.createForm.img_list = [];
            }).catch(function (err) {
              _this3.$message({
                message: '创建失败',
                type: 'error'
              });
            });
          }
        }
      });
    },
    /**
     * 重置查询条件
     */
    resetQuery: function resetQuery() {
      this.queryParams = {
        add_date: [] // 重置日期范围
      };
      this.currentPage = 1;
      this.fetchData();
    },
    /**
     * 创建记录
     */
    handleCreate: function handleCreate() {
      var in_aid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var in_store_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var in_contact = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var in_content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var in_goods_type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '3';
      var in_record_type = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '4';
      // 如果in_aid是对象，则将其设置为空字符串
      if (_typeof(in_aid) === 'object') {
        in_aid = '';
      }
      this.isEdit = false; // 设置为新建状态
      this.createForm = {
        aid: in_aid,
        store_id: in_store_id,
        goods_sn: '',
        goods_type: in_goods_type,
        record_type: in_record_type,
        contact: in_contact,
        content: in_content,
        record: '',
        status: '0',
        add_person: '',
        img_list: [] // 添加图片列表字段
      };
      this.agentList = []; // 清空代理列表
      this.storeList = []; // 清空商户列表
      // 清空图片列表
      this.fileList = [];
      this.createDialogVisible = true;
    },
    /**
     * 删除
     * @param row
     */
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function (res) {
        // 【操作埋点】2026-05-25 pc_customer_record_delete_1 删除客服跟进记录
        _this4.$delete('agentapi/customer_record/delete', {
          id: row.id
        }).then(function (res) {
          _this4.$customerRecordReport.reportCustomerRecordDelete(row.id, row);
          _this4.$message({
            message: '删除成功',
            type: 'success'
          });
          // 删除后强制刷新整个列表
          _this4.fetchData();
        }).catch(function () {
          _this4.$message({
            message: '删除失败',
            type: 'error'
          });
          // 即使删除失败也刷新列表以确保数据一致性
          _this4.fetchData();
        });
      }).catch(function () {
        // 用户取消删除操作也刷新列表
        _this4.fetchData();
      });
    },
    /**
     * 获取代理列表（用于搜索）
     */
    fetchAgentList: function fetchAgentList(query) {
      var _this5 = this;
      var aid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.$get('agentapi/customer_record/get_aid_list', {
        aid: aid,
        name: query
      }).then(function (res) {
        _this5.agentList = res || [];
      }).catch(function (err) {
        console.error('获取代理列表失败:', err);
        _this5.agentList = [];
      });
    },
    /**
     * 获取商户列表（用于搜索）
     */
    fetchStoreList: function fetchStoreList(query) {
      var _this6 = this;
      var store_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.$get('agentapi/customer_record/get_store_id_list', {
        store_id: store_id,
        store_name: query
      }).then(function (res) {
        _this6.storeList = res || [];
      }).catch(function (err) {
        console.error('获取商户列表失败:', err);
        _this6.storeList = [];
      });
    },
    /**
     * 处理代理搜索（防抖处理）
     */
    handleAgentSearch: function handleAgentSearch(query) {
      var _this7 = this;
      // 清除之前的定时器
      if (this.agentSearchTimer) {
        clearTimeout(this.agentSearchTimer);
      }

      // 设置新的定时器，延迟300ms执行搜索
      this.agentSearchTimer = setTimeout(function () {
        if (query !== '') {
          _this7.fetchAgentList(query);
        } else {
          _this7.agentList = [];
        }
      }, 300);
    },
    /**
     * 处理商户搜索（防抖处理）
     */
    handleStoreSearch: function handleStoreSearch(query) {
      var _this8 = this;
      // 清除之前的定时器
      if (this.storeSearchTimer) {
        clearTimeout(this.storeSearchTimer);
      }

      // 设置新的定时器，延迟300ms执行搜索
      this.storeSearchTimer = setTimeout(function () {
        if (query !== '') {
          _this8.fetchStoreList(query);
        } else {
          _this8.storeList = [];
        }
      }, 300);
    },
    /**
     * 根据状态中文名称获取对应的值
     * @param {string} statusName - 状态中文名称
     * @returns {string} 对应的值
     */
    getStatusValue: function getStatusValue(statusName) {
      var status = this.statusOptions.find(function (option) {
        return option.label === statusName;
      });
      return status ? status.value : '0'; // 默认返回"待处理"的值
    },
    /**
     * 根据问题类型中文名称获取对应的值
     * @param {string} typeName - 问题类型中文名称
     * @returns {string} 对应的值
     */
    getRecordTypeValue: function getRecordTypeValue(typeName) {
      var type = this.recordTypeOptions.find(function (option) {
        return option.label === typeName;
      });
      return type ? type.value : '4'; // 默认返回"代理回访"的值
    },
    /**
     * 根据设备类型中文名称获取对应的值
     * @param goodsTypeName
     * @returns {string|*}
     */
    getGoodsTypeValue: function getGoodsTypeValue(goodsTypeName) {
      var type = this.goodsTypeOptions.find(function (option) {
        return option.label === goodsTypeName;
      });
      return type ? type.value : '3'; // 默认返回"密码线"的值
    },
    /**
     * 图片上传成功处理
     */
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      // 根据实际后端返回格式处理 {code: 0, data: {file_url: '图片地址'}}
      if (response && response.code === 0 && response.data && response.data.file_url) {
        this.$message.success('图片上传成功');
        // 更新文件列表中的URL
        file.url = response.data.file_url;
        this.fileList = fileList;
      } else {
        this.$message.error('图片上传失败');
        // 从文件列表中移除上传失败的文件
        var index = this.fileList.indexOf(file);
        if (index !== -1) {
          this.fileList.splice(index, 1);
        }
      }
    },
    /**
     * 图片上传失败处理
     */
    handleUploadError: function handleUploadError(err, file, fileList) {
      this.$message.error('图片上传失败');
      console.error('图片上传失败:', err);
    },
    /**
     * 图片移除处理
     */
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    /**
     * 图片预览处理
     */
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    }
  }
};